module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('div', {
    staticClass: "col-md-3"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-aqua",
      "bgIcon": "ion ion-ios-gear-outline",
      "text": "Hello",
      "number": "8700"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-red",
      "bgIcon": "fa fa-google-plus",
      "text": "LIKES",
      "number": "232323",
      "number-type": "percentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-green",
      "bgIcon": "ion ion-ios-cart-outline",
      "text": "SALES",
      "number": "580"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-yellow",
      "bgIcon": "ion ion-ios-people-outline",
      "text": "new members",
      "number": "580",
      "number-type": "comma"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5d7fdb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/InfoBoxExample.vue
// module id = 543
// module chunks = 1